import { Component, OnInit } from '@angular/core';

declare global {
  interface PerformanceEntry {
    type: string;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public ngOnInit(): void {
    if (performance.getEntriesByType('navigation')[0].type === 'back_forward') {
      location.reload();
    }
  }
}
